import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; // Import axios
import {
  Container,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Box,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import API_BASE_URL from "../../src/config";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(""); // To handle errors

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(""); // Clear any previous error

    if (!email) {
      setError("Please enter a valid email.");
      setLoading(false);
      return;
    }

    try {
      // 🔁 Changed from GET to POST to match your backend
      const response = await axios.post(`${API_BASE_URL}/users/forgot`, {
        email: email,
      });

      if (response.data.exists) {
        alert(`Password reset link sent to ${email}`);
        // Optionally navigate to another page
        navigate("/reset-password");
      } else {
        setError(response.data.message || "Email not found.");
      }
    } catch (err) {
      setError(
        err.response?.data?.message || "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 5, mb: 4 }}>
      <Card sx={{ p: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography
            variant="h5"
            color="#42326e"
            fontWeight="bold"
            textAlign="center"
          >
            Forgot Password?
          </Typography>
          <Typography variant="body2" textAlign="center" sx={{ mt: 1, mb: 3 }}>
            Enter your email, and we'll send you a password reset link.
          </Typography>

          {error && (
            <Typography color="error" textAlign="center" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}

          <form onSubmit={handleReset}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <EmailIcon color="action" />
              <TextField
                fullWidth
                label="Email Address"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Box>

            <Button
              variant="contained"
              fullWidth
              sx={{
                mt: 3,
                backgroundColor: "#42326e",
                color: "white",
                "&:hover": {
                  backgroundColor: "black",
                  color: "white",
                },
              }}
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Reset Password"
              )}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Container>
  );
};

export default ForgotPassword;
